class CartUpsellPopup extends HTMLElement {
  constructor() {
    super();
    this.productId = String(this.dataset.productId || '');
    this.variantId = this.dataset.variantId;
    this.checkoutUrl = this.dataset.checkoutUrl || '/checkout';
    this.addButton = this.querySelector('[data-cart-upsell-add]');
    this.errorEl = this.querySelector('[data-cart-upsell-error]');
    this.passThroughUntil = 0;

this.querySelector('[data-cart-upsell-close]').addEventListener('click', () => this.skip());
this.querySelector('.cart-upsell-popup__overlay').addEventListener('click', () => this.skip());
    this.querySelector('[data-cart-upsell-skip]').addEventListener('click', () => this.skip());
    this.addButton.addEventListener('click', () => this.add());
    this.addEventListener('click', (e) => e.stopPropagation());

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || this.hidden) return;
      this.swallowEscape = true;
      this.dismiss();
    });
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && this.swallowEscape) {
        this.swallowEscape = false;
        e.stopPropagation();
      }
    });

    this.initGallery();
    this.initOptions();
    window.addEventListener('click', (e) => this.onCheckoutClick(e), true);
  }

  onCheckoutClick(event) {
    const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
    const form = button && button.closest('form');
    if (!form || !this.productId) return;
    if (Date.now() < this.passThroughUntil || this.wasDeclined()) return;
    const terms = form.querySelector('.cart__terms-checkbox');
    if (terms && !terms.checked) return;
    if ([...form.querySelectorAll('[data-product-id]')].some((el) => el.dataset.productId === this.productId)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.pendingButton = button;
    this.pendingForm = form;
    this.open();
  }

  open() {
    this.isAdding = false;
    this.showError('');
    this.addButton.classList.remove('btn--loading');
    this.addButton.disabled = false;
    this.hidden = false;
    document.documentElement.classList.add('cart-upsell-popup--open');
    this.resetGallery();
    this.resetOptions();
    this.startAutoplay();
  }

  hide() {
    this.stopAutoplay();
    this.hidden = true;
    document.documentElement.classList.remove('cart-upsell-popup--open');
  }

  decline() {
    try { sessionStorage.setItem('cartUpsellDeclined', '1'); } catch (e) {}
    this.declined = true;
  }

  wasDeclined() {
    if (this.declined) return true;
    try { return sessionStorage.getItem('cartUpsellDeclined') === '1'; } catch (e) { return false; }
  }

  dismiss() {
    if (this.isAdding || this.hidden) return;
    this.decline();
    this.hide();
  }

  skip() {
    if (this.isAdding || this.hidden) return;
    this.decline();
    this.hide();
    const button = this.pendingButton;
    const form = this.pendingForm;
    this.passThroughUntil = Date.now() + 10000;
    if (button && button.isConnected) button.click();
    else if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  }

  showError(message) {
    this.errorEl.textContent = message;
    this.errorEl.hidden = !message;
  }

  add() {
    if (this.isAdding) return;
    if (!this.variantId) {
      const missing = this.missingOptionName();
      this.showError(missing ? 'אנא בחרי ' + missing : 'האפשרות שנבחרה אזלה מהמלאי');
      return;
    }

    const fail = (message) => {
      this.isAdding = false;
      this.addButton.classList.remove('btn--loading');
      this.addButton.disabled = false;
      this.showError(message || 'משהו השתבש, נסי שוב');
    };

    this.isAdding = true;
    this.showError('');
    this.addButton.classList.add('btn--loading');
    this.addButton.disabled = true;

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(this.variantId), quantity: 1 }] })
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) return fail(data.description || data.message);
        window.location.href = this.checkoutUrl;
      })
      .catch(() => fail());
  }

  initGallery() {
    this.track = this.querySelector('[data-cart-upsell-track]');
    if (!this.track) return;
    this.slides = [...this.track.querySelectorAll('[data-cart-upsell-slide]')];
    this.dots = [...this.querySelectorAll('[data-cart-upsell-dot]')];
    this.currentSlide = 0;
    if (this.slides.length < 2) return;

    this.querySelector('[data-cart-upsell-prev]').addEventListener('click', () => this.goToSlide(this.currentSlide - 1, true));
    this.querySelector('[data-cart-upsell-next]').addEventListener('click', () => this.goToSlide(this.currentSlide + 1, true));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.goToSlide(Number(dot.dataset.cartUpsellDot), true)));
    ['pointerdown', 'touchstart', 'wheel'].forEach((type) => {
      this.track.addEventListener(type, () => this.stopAutoplay(), { passive: true });
    });
    this.track.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      this.goToSlide(this.currentSlide + (e.key === 'ArrowLeft' ? 1 : -1), true);
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) this.setActiveSlide(this.slides.indexOf(entry.target));
      });
    }, { root: this.track, threshold: 0.6 });
    this.slides.forEach((slide) => observer.observe(slide));
  }

  goToSlide(index, byUser) {
    if (!this.slides || this.slides.length < 2) return;
    if (byUser) this.stopAutoplay();
    const target = (index + this.slides.length) % this.slides.length;
    const offset = this.slides[target].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
    this.track.scrollBy({ left: offset, behavior: 'smooth' });
    this.setActiveSlide(target);
  }

  setActiveSlide(index) {
    if (index < 0) return;
    this.currentSlide = index;
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }

  resetGallery() {
    if (!this.slides || this.slides.length < 2) return;
    this.track.scrollBy({ left: this.slides[0].getBoundingClientRect().left - this.track.getBoundingClientRect().left });
    this.setActiveSlide(0);
  }

  startAutoplay() {
    this.stopAutoplay();
    const seconds = Number(this.dataset.autoplaySeconds || 0);
    if (!seconds || !this.slides || this.slides.length < 2) return;
    this.autoplayTimer = setInterval(() => {
      if (!this.hidden && !document.hidden) this.goToSlide(this.currentSlide + 1);
    }, seconds * 1000);
  }

  stopAutoplay() {
    clearInterval(this.autoplayTimer);
  }

  initOptions() {
    this.priceEl = this.querySelector('[data-cart-upsell-price]');
    this.optionGroups = [...this.querySelectorAll('[data-cart-upsell-option]')];
    this.valueButtons = [...this.querySelectorAll('.cart-upsell-popup__value')];
    const json = this.querySelector('[data-cart-upsell-variants]');
    this.variants = json ? JSON.parse(json.textContent) : [];
    this.valueButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.selectedOptions[Number(button.dataset.optionIndex)] = button.dataset.value;
        this.updateSelection();
      });
    });
  }

  resetOptions() {
    if (!this.optionGroups.length) return;
    this.selectedOptions = this.optionGroups.map((group) => {
      const values = group.querySelectorAll('.cart-upsell-popup__value');
      return values.length === 1 ? values[0].dataset.value : null;
    });
    this.updateSelection();
  }

  isValueAvailable(optionIndex, value) {
    return this.variants.some((v) => v.available && v.options.every((opt, i) =>
      i === optionIndex ? opt === value : this.selectedOptions[i] === null || this.selectedOptions[i] === opt
    ));
  }

  updateSelection() {
    this.valueButtons.forEach((button) => {
      const index = Number(button.dataset.optionIndex);
      const selected = this.selectedOptions[index] === button.dataset.value;
      const available = this.isValueAvailable(index, button.dataset.value);
      button.classList.toggle('is-selected', selected);
      button.classList.toggle('is-unavailable', !available);
      button.setAttribute('aria-pressed', selected);
      button.disabled = !available;
      if (selected && !available) this.selectedOptions[index] = null;
    });

    const variant = this.selectedOptions.includes(null)
      ? null
      : this.variants.find((v) => v.options.every((opt, i) => opt === this.selectedOptions[i]));
    this.variantId = variant && variant.available ? String(variant.id) : '';
    if (variant) this.updatePrice(variant);
    if (this.variantId) this.showError('');
  }

  updatePrice(variant) {
    const format = (cents) => theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    this.priceEl.innerHTML = variant.compare_at_price > variant.price
      ? `<s class="cart-upsell-popup__compare">${format(variant.compare_at_price)}</s><span class="cart-upsell-popup__sale">${format(variant.price)}</span>`
      : format(variant.price);
  }

  missingOptionName() {
    const index = this.selectedOptions ? this.selectedOptions.indexOf(null) : -1;
    return index === -1 ? '' : this.optionGroups[index].dataset.optionName;
  }
}

if (!customElements.get('cart-upsell-popup')) customElements.define('cart-upsell-popup', CartUpsellPopup);